import { render, staticRenderFns } from "./ForeignOfferLot.vue?vue&type=template&id=485e54a3"
import script from "./ForeignOfferLot.vue?vue&type=script&lang=js"
export * from "./ForeignOfferLot.vue?vue&type=script&lang=js"
import style0 from "./ForeignOfferLot.vue?vue&type=style&index=0&id=485e54a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports